import { TermsComponentdetailsItemDiv, TermsComponentHeroMainDiv, TermsComponentMainDiv } from "../../styles/termscomponentsstyles/termscomponentstyle"
import Footer from "../reusable/footer/footer"
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan"
import HeaderComponent from "../reusable/header/header"

const TermsComponent = () => {

    return (
        <TermsComponentMainDiv>
            <div className="header-holder">
                <HeaderComponent />
            </div>
            <TermsComponentHeroMainDiv>
                <div>
                    <div className="terms-container">
                        <div className="terms-header-container">
                            <div>
                                <div>
                                    <HeaderSpan text="Terms & Conditions

" />
                                </div>
                            </div>
                            <div>
                                <div className="terms-header-text-container">
                                    <h1> Terms & Conditions

</h1>
                                </div>
                            </div>
                        </div>
                        <div className="terms-body-container">
                            {data.map((item, index) => (
                                <TermsComponentdetailsItemDiv>
                                    <div className="terms-left-col">
                                        <div className="">
                                            <h3>August Update</h3>
                                        </div>
                                        <div>
                                            <div className="terms-text-wrapper ">
                                                <p>Release: v1.3</p>
                                            </div>
                                            <div className="terms-text-wrapper ">
                                                <p>Aug 10, 2025</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="terms-right-col">

                                        <div className="terms-body-text-container">

                                            <div className="terms-texts-container">
                                                <div>
                                                    <div className="terms-detail-text-wrapper">
                                                        <h3 >ChatGPT: Better Writing</h3>
                                                    </div>
                                                </div>
                                                <div className="terms-details-detial-wrapper">
                                                    <div className="terms-detail-detail-wrapper">

                                                        <div className="terms-detail-text-wrapper">
                                                            <p>
                                                                We collect data to ensure seamless interactions and personalized experiences. When you use our services, we may collect personal details such as your name, email, and phone number. Additionally, we track your interactions with our website, including the pages you visit, the device you use, and the time spent on specific sections. Cookies are also used to store preferences and enhance functionality. All data collected is handled responsibly to maintain transparency and build trust.

                                                            </p>
                                                        </div>
                                                    </div>





                                                </div>
                                            </div>

                                            <div className="terms-texts-container">
                                                <div>
                                                    <div className="terms-detail-text-wrapper">
                                                        <h3 >ChatGPT: Better Writing</h3>
                                                    </div>
                                                </div>
                                                <div className="terms-details-detial-wrapper">
                                                    
                                                    
                                                    <div className="terms-detail-detail-wrapper">

                                                        <div className="terms-detail-text-wrapper">
                                                            <p><b>Here comes the sun </b> 
                                                            We collect data to ensure seamless interactions and personalized experiences. When you use our services, we may collect personal details such as your name, email, and phone number. Additionally, we track your interactions with our website, including the pages you visit, the device you use, and the time spent on specific sections. Cookies are also used to store preferences and enhance functionality. All data collected is handled responsibly to maintain transparency and build trust.

                                                            </p>
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TermsComponentdetailsItemDiv>
                            ))}
                        </div>
                    </div>
                </div>
            </TermsComponentHeroMainDiv>
            

            <div>
                <Footer />
            </div>
        </TermsComponentMainDiv>
    )
}

const data = ["" ]
export default TermsComponent